import React, { useState } from "react";
import { authService } from "../services/authService";
import { Link } from "react-router-dom";
const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState();
  const [loading, setLoading] = useState(false);

  // Regex kiểm tra email hợp lệ
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // Xử lý khi thay đổi input
  const handleChange = (e) => {
    setEmail(e.target.value);
    setError("");
    setSuccess(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);
    if (!email.trim()) {
      setError("Email không được để trống!");
      return;
    }
    if (!emailRegex.test(email)) {
      setError("Email không hợp lệ!");
      return;
    }
    setLoading(true);
    try {
      const response = await authService.forgotPassword(email);
      setSuccess(response.data.status);
    } catch (error) {
      console.error("Lỗi:", error);
      setError(error.response?.data?.message || "Có lỗi xảy ra!");
    } finally {
      setLoading(false); // Dừng loading sau khi có kết quả
    }
  };
  return (
    <>
      <div className="main-wrapper authentication-wrapper">
        <div className="container-fuild">
          <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
            <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
              <div className="col-xxl-4 col-lg-6 col-md-6 col-11 mx-auto">
                <div
                  className="p-4 text-center"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src="assets/img/logo-dark.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <div className="card authentication-card">
                  <div className="card-header">
                    <div className="text-center">
                      <h5 className="mb-1">Quên mật khẩu</h5>
                      <p>Đặt lại mật khẩu DreamsTour</p>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <div className="input-icon">
                        <span className="input-icon-addon">
                          <i className="isax isax-message"></i>
                        </span>
                        <input
                          type="email"
                          name="email"
                          className="form-control form-control-lg"
                          placeholder="Nhập Email"
                          value={email}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="mb-4">
                      {error ? (
                        <p className="text-danger">
                          <i className="fas fa-times-circle me-1"></i>
                          {error}
                        </p>
                      ) : success ? (
                        <p className="text-success">
                          <i className="isax isax-tick-circle5 me-1"></i>
                          Xác nhận tại email: “{email}”.
                        </p>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <button
                        type="submit"
                        className="btn btn-xl btn-primary d-flex align-items-center justify-content-center w-100"
                        onClick={handleSubmit}
                        disabled={loading} // Vô hiệu hóa nút khi đang gửi yêu cầu
                      >
                        {loading ? (
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                          ></span>
                        ) : (
                          <>
                            Đặt lại mật khẩu
                            <i className="isax isax-arrow-right-3 ms-2"></i>
                          </>
                        )}
                      </button>
                    </div>

                    <div className="d-flex justify-content-center">
                      <p className="fs-14">
                        Nhớ mật khẩu ?{" "}
                        <Link to="/login" className="link-primary fw-medium">
                          Đăng nhập
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="coprright-footer">
          <p className="fs-14">
            Copyright &copy; 2025. All Rights Reserved,{" "}
            <a href="javascript:void(0);" className="text-primary fw-medium">
              DreamsTour
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordPage;
